module.exports = __webpack_public_path__ + "4e335cdd69e993363afa5e9e38d9bb73.svg";